import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, TextField } from '@material-ui/core';
import { FaSave } from 'react-icons/fa'
import { FaPlus } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { changeScreen } from '../../../store/actions/navigation.action';
import { credential, success as changeSuccess } from '../../../store/actions/mercadopago.action'
import { useDispatch } from 'react-redux';

export default function MercadopagoEdit() {
    const dispatch = useDispatch()

    const [state, setState] = React.useState(null)

    React.useEffect(() => {
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">Configurar Conta</Typography>

                        {(state) &&
                            <Button color="inherit" className="ms-auto" onClick={() => dispatch(credential({code: state}))}>
                                <FaSave className="me-2" /> Salvar
                            </Button>
                        }
                    </Toolbar>
                </AppBar>

                <div className="card card-body mt-3">
                    <div className="mb-3">
                        <label className="label-custom">CODE</label>
                        <TextField
                            placeholder="Informe o código solicitado"
                            value={state || ''}
                            onChange={ text => setState(text.target.value)}
                        />
                    </div>

                    <div className="mb-3">
                        <a href="https://auth.mercadopago.com.br/authorization?client_id=2092805717840015&response_type=code&platform_id=mp&state=RANDOM_ID&redirect_uri=https://api.eedgecloud.com/mercadopago/redirect" target="_blank" rel="noopener noreferrer">
                            <button type="button" className="btn btn-sm btn-success rounded-0">
                                <FaPlus size="1em" className="me-2" /> Solicitar Código
                            </button>
                        </a>
                    </div> 
                </div>
            </div>
        </>
    )
}